export const BASE_PATH = "/src/assets/models/";
export const PNG = ".png";
export const UNKNOWN = "unknown";
export const UNKNOWN_MODEL = "Unknown model";
